module.exports = __webpack_public_path__ + "5a3ece6ae2f212f1e563fabce28e4a7b.png";